<script setup lang="ts">
import { SharedData } from '@/@types'

import { Link, usePage } from '@inertiajs/vue3'

const { user } = usePage<SharedData>().props
</script>

<template>
    <nav class="hidden lg:block">
        <ul
            class="flex items-center gap-x-2 text-sm group-data-[dark=false]:text-gray-900 group-data-[dark=true]:text-white 2xl:gap-x-5 2xl:text-base"
        >
            <li>
                <Link href="/">{{ $t('Home') }}</Link>
            </li>
            <li v-if="!(user?.role === 'admin')">
                <Link href="/#tickets">{{ $t('Buy tickets') }}</Link>
            </li>   
            <template v-if="user">
                <li>
                    <Link href="/orders">{{ $t('My orders') }}</Link>
                </li>
                <li v-if="user.active_for_invited">
                    <Link href="/participant/mailings">{{ $t('My ticket') }}</Link>
                </li>
                <template v-if="user.role == 'admin'">
                    <li>
                        <Link href="/coupons">{{ $t('Manage coupons') }}</Link>
                    </li>
                    <li>
                        <Link href="/admin/mailings">Gerenciar ingresso</Link>
                    </li>
                    <li>
                        <Link href="/admin/orders">{{ $t('Manage orders') }}</Link>
                    </li>
                    <li>
                        <Link href="/admin/reports/sellers">Relatórios</Link>
                    </li>
                </template>
            </template>
        </ul>
    </nav>
</template>
